import Body from '@service-victoria/component-library/components/Text/Body';
import styled from 'styled-components';

export const PrivacyContainer = styled.div`
  margin-top: 72px;
`;

export const PrivacyContainerHeaderText = styled(Body)`
  font-size: 18px;
  font-weight: 600;
`;
